export const CHECKOUT_EVENT_LOCATION = "checkout";
export const ORDER_CONFIRMATION_EVENT_LOCATION = "order_confirmation";

export const PAY_TARGET = "pay";
export const ITEMS_TARGET = "items";
export const ORDERS_TARGET = "orders";
export const HOME_TARGET = "home";
export const RECEIPT_TARGET = "receipt";
export const TRACKING_LINK_TARGET = "tracking_link";
